import api from './axios';

export interface OnboardingStep {
  step: 'branding_configured' | 'first_product_created' | 'first_staff_added' | 'certificate_template_configured' | 'stp_rules_configured';
  label: string;
  completed: boolean;
  required: boolean;
  action_url: string;
  optional?: boolean;
}

export interface OnboardingStatus {
  steps: OnboardingStep[];
  completion_percentage: 0 | 25 | 50 | 75 | 100;
  trial_days_remaining: number;
  trial_end: string;
  onboarding_completed: boolean;
  subscription_status?: 'active' | 'trial' | 'locked' | 'cancelled' | 'suspended' | 'attention' | 'past_due';
  tier?: string;
  billing_cycle?: string;
  amount?: number;
  currency?: string;
  current_period_end?: string;
  enabled_add_ons?: string[];
}

export async function getOnboardingStatus(): Promise<OnboardingStatus> {
  const { data } = await api.get<{ data: OnboardingStatus }>('/api/v2/onboarding/status');
  return data.data;
}
